import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('tl_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tl_token');
    if (token) {
      api.get('/auth/me')
        .then(res => {
          setUser(res.data.user);
          localStorage.setItem('tl_user', JSON.stringify(res.data.user));
        })
        .catch(() => {
          localStorage.removeItem('tl_token');
          localStorage.removeItem('tl_user');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const refreshUser = async () => {
    const res = await api.get('/auth/me');
    const refreshed = res.data.user;
    localStorage.setItem('tl_user', JSON.stringify(refreshed));
    setUser(refreshed);
    return refreshed;
  };

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('tl_token', res.data.token);
    localStorage.setItem('tl_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (data) => {
    const res = await api.post('/auth/register', data);
    localStorage.setItem('tl_token', res.data.token);
    localStorage.setItem('tl_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const updateUser = async (data) => {
    const res = await api.put('/auth/me', data);
    const updated = res.data.user;
    localStorage.setItem('tl_user', JSON.stringify(updated));
    setUser(updated);
    return updated;
  };

  const logout = () => {
    localStorage.removeItem('tl_token');
    localStorage.removeItem('tl_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, updateUser, refreshUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
